module.exports = __webpack_public_path__ + "static/media/icon.2f1ae046.png";